import { AppImages } from "app/appImages";
import { CustomVideoSlideRender } from "components/CustomVideoSlideRender";
import { FileGetDto } from "generated/CoreApi_v1";
import * as React from 'react';
import "react-image-crop/dist/ReactCrop.css";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    open?: boolean;
    file: FileGetDto;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export const MprcMediaViewer: React.FC<IProps> = ({ open = true, file, onClose }) => {
    return (
        <Lightbox
            open={open}
            close={onClose}
            slides={
                file.mimetype.startsWith("image")
                    ? [{
                        type: "image",
                        src: file.url!,
                        description: file.metadata.title,
                        height: file.metadata.height!,
                        width: file.metadata.width!,
                    }]
                    : file.mimetype.startsWith("audio") || file.mimetype.startsWith("video")
                        ? [{
                            type: "custom-video-slide",
                            id: file.fileId,
                            videoId: file.fileId,
                            url: file.url!,
                            description: file.metadata.title,
                            height: file.metadata.height!,
                            width: file.metadata.width!,
                            duration: file.metadata.duration ?? 0,
                            mimetype: file.mimetype,
                            isAudio: file.mimetype.indexOf("audio") > -1,
                            isHls: false,
                            autoPlay: true,
                            mediaSessionTitle: file.metadata.title,
                            title: file.metadata.title,
                            poster: file.mimetype.indexOf("audio") > -1
                                ? AppImages.AudioPoster
                                : AppImages.VideoMp4Poster,
                            tracks: file.mediaTracks ?? []
                        }]
                        : []
            }
            render={
                {
                    slide: ({ slide, offset }) =>
                        "type" in slide && slide.type === "custom-video-slide" && offset == 0
                            ? <CustomVideoSlideRender slide={slide} offset={offset} />
                            : null,

                    buttonPrev: () => null,
                    buttonNext: () => null
                }
            }
            zoom={{
                maxZoomPixelRatio: 1,
                zoomInMultiplier: 2,
                doubleTapDelay: 300,
                doubleClickDelay: 300,
                doubleClickMaxStops: 2,
                keyboardMoveDistance: 50,
                wheelZoomDistanceFactor: 100,
                pinchZoomDistanceFactor: 100,
                scrollToZoom: true
            }}
            plugins={file.mimetype.startsWith("image") ? [Captions, Fullscreen, Zoom] : []}
        />
    );
};
